"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPricing;
exports.getLatestVersionNumber = getLatestVersionNumber;
exports.getLeatherGoodsPricing = getLeatherGoodsPricing;
exports.getLeatherGoodsPricingInverse = getLeatherGoodsPricingInverse;
exports.getMetadata = getMetadata;
exports.getPricingInverse = getPricingInverse;
exports.getUpcyclingPricing = getUpcyclingPricing;
exports.getUpcyclingPricingInverse = getUpcyclingPricingInverse;
var _pricings = _interopRequireWildcard(require("./v1/pricings"));
var _pricings2 = _interopRequireWildcard(require("./v2/pricings"));
var _pricings3 = _interopRequireWildcard(require("./v3/pricings"));
var _pricings4 = _interopRequireWildcard(require("./v4/pricings"));
var _pricings5 = _interopRequireWildcard(require("./v5/pricings"));
var _pricings6 = _interopRequireWildcard(require("./v6/pricings"));
var _pricings7 = _interopRequireWildcard(require("./v7/pricings"));
var _pricings8 = _interopRequireWildcard(require("./v8/pricings"));
var _pricings9 = _interopRequireWildcard(require("./v9/pricings"));
var _pricings10 = _interopRequireWildcard(require("./v10/pricings"));
var _pricings11 = _interopRequireWildcard(require("./v11/pricings"));
var _pricings12 = _interopRequireWildcard(require("./v12/pricings"));
var _pricings13 = _interopRequireWildcard(require("./v13/pricings"));
var _pricings14 = _interopRequireWildcard(require("./v14/pricings"));
var _upcyclingPricing = _interopRequireWildcard(require("./upcyclingPricing"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var latestVersionNumber = 13; // Keep v13 instead of v14 for now, because v13 is the last version work for France.

function getLatestVersionNumber() {
  return latestVersionNumber;
}
function getPricing(pricingVersion) {
  switch (pricingVersion) {
    case 14:
      return _pricings14["default"];
    case 13:
      return _pricings13["default"];
    case 12:
      return _pricings12["default"];
    case 11:
      return _pricings11["default"];
    case 10:
      return _pricings10["default"];
    case 9:
      return _pricings9["default"];
    case 8:
      return _pricings8["default"];
    case 7:
      return _pricings7["default"];
    case 6:
      return _pricings6["default"];
    case 5:
      return _pricings5["default"];
    case 4:
      return _pricings4["default"];
    case 3:
      return _pricings3["default"];
    case 2:
      return _pricings2["default"];
    case 1:
    default:
      return _pricings["default"];
  }
}
function getPricingInverse(pricingVersion) {
  switch (pricingVersion) {
    case 14:
      return _pricings14.pricingInverse;
    case 13:
      return _pricings13.pricingInverse;
    case 12:
      return _pricings12.pricingInverse;
    case 11:
      return _pricings11.pricingInverse;
    case 10:
      return _pricings10.pricingInverse;
    case 9:
      return _pricings9.pricingInverse;
    case 8:
      return _pricings8.pricingInverse;
    case 7:
      return _pricings7.pricingInverse;
    case 6:
      return _pricings6.pricingInverse;
    case 5:
      return _pricings5.pricingInverse;
    case 4:
      return _pricings4.pricingInverse;
    case 3:
      return _pricings3.pricingInverse;
    case 2:
      return _pricings2.pricingInverse;
    case 1:
    default:
      return _pricings.pricingInverse;
  }
}
function getMetadata(pricingVersion) {
  switch (pricingVersion) {
    case 14:
      return _pricings14.metadata;
    case 13:
      return _pricings13.metadata;
    case 12:
      return _pricings12.metadata;
    case 11:
      return _pricings11.metadata;
    case 10:
      return _pricings10.metadata;
    case 9:
      return _pricings9.metadata;
    case 8:
      return _pricings8.metadata;
    case 7:
      return _pricings7.metadata;
    case 6:
      return _pricings6.metadata;
    case 5:
      return _pricings5.metadata;
    case 4:
      return _pricings4.metadata;
    case 3:
      return _pricings3.metadata;
    case 2:
      return _pricings2.metadata;
    case 1:
    default:
      return _pricings.metadata;
  }
}
function getUpcyclingPricing(pricingVersion) {
  switch (pricingVersion) {
    case 14:
      return _pricings14.upcyclingPricing;
    case 13:
      return _pricings13.upcyclingPricing;
    case 12:
      return _pricings12.upcyclingPricing;
    case 11:
      return _pricings11.upcyclingPricing;
    case 10:
      return _pricings10.upcyclingPricing;
    case 9:
      return _pricings9.upcyclingPricing;
    default:
      return _upcyclingPricing["default"];
  }
}
function getUpcyclingPricingInverse(pricingVersion) {
  switch (pricingVersion) {
    case 14:
      return _pricings14.upcyclingPricingInverse;
    case 13:
      return _pricings13.upcyclingPricingInverse;
    case 12:
      return _pricings12.upcyclingPricingInverse;
    case 11:
      return _pricings11.upcyclingPricingInverse;
    case 10:
      return _pricings10.upcyclingPricingInverse;
    case 9:
      return _pricings9.upcyclingPricingInverse;
    default:
      return _upcyclingPricing.upcyclingPricingInverse;
  }
}
function getLeatherGoodsPricing(pricingVersion) {
  switch (pricingVersion) {
    case 14:
      return _pricings14.leatherGoodsPricing;
    case 13:
      return _pricings13.leatherGoodsPricing;
    case 12:
      return _pricings12.leatherGoodsPricing;
    case 11:
      return _pricings11.leatherGoodsPricing;
    case 10:
      return _pricings10.leatherGoodsPricing;
    case 9:
      return _pricings9.leatherGoodsPricing;
    default:
      return _pricings9.leatherGoodsPricing;
  }
}
function getLeatherGoodsPricingInverse(pricingVersion) {
  switch (pricingVersion) {
    case 14:
      return _pricings14.leatherGoodsPricingInverse;
    case 13:
      return _pricings13.leatherGoodsPricingInverse;
    case 12:
      return _pricings12.leatherGoodsPricingInverse;
    case 11:
      return _pricings11.leatherGoodsPricingInverse;
    case 10:
      return _pricings10.leatherGoodsPricingInverse;
    case 9:
      return _pricings9.leatherGoodsPricingInverse;
    default:
      return _pricings9.leatherGoodsPricingInverse;
  }
}